/** Mirror of backend/utils/smsSegments.js for live compose feedback. */

export function isGsm7(text) {
  for (let i = 0; i < text.length; i += 1) {
    const c = text.charCodeAt(i);
    if (c === 0x20ac || c > 0x7f) return false;
  }
  return true;
}

export function countSegments(body) {
  const text = String(body || "");
  if (text.length === 0) return 0;
  const gsm = isGsm7(text);
  const len = text.length;
  if (gsm) {
    if (len <= 160) return 1;
    return Math.ceil(len / 153);
  }
  if (len <= 70) return 1;
  return Math.ceil(len / 67);
}

export function segmentCharLimit(text) {
  return isGsm7(text) ? 160 : 70;
}

export function encodingLabel(text) {
  return isGsm7(text) ? "GSM (Latin)" : "Unicode (Cyrillic / emoji)";
}
